import React from "react";
import Layout from "../components/layout/LPLayout";
import { SEO } from "wmk-lib";
import get from "lodash/get";
import LogoSVG from "../components/common/LogoSVG";
import { Col, Container, Row } from "react-bootstrap";

const IndexPage = ({ pageContext }) => (
  <Layout>
    <SEO.Meta
      title={`Watermark Inbound`}
      path={"/"}
      slug={get(pageContext, `page.slug`)}
      //description={description}
      ogImage={null}
      twitterImage={null}
      twitterHandle={"@WatermarkAgency"}
      siteTitle={"Watermark Agency"}
      baseUrl={"https://inbound.wmkagency.com"}
    />
    <Container style={{ minHeight: "80vh" }}>
      <Row style={{ minHeight: "80vh" }}>
        <Col
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <LogoSVG />
        </Col>
      </Row>
    </Container>
  </Layout>
);

export default IndexPage;
